import { render } from "./ProductManagementTable.vue?vue&type=template&id=4441e2c8&scoped=true"
import script from "./ProductManagementTable.vue?vue&type=script&lang=js"
export * from "./ProductManagementTable.vue?vue&type=script&lang=js"

import "./ProductManagementTable.vue?vue&type=style&index=0&id=4441e2c8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4441e2c8"]])

export default __exports__